'use strict';

const Mn = require('backbone.marionette');
require('magnific-popup');
const ElementCommunication = require('./element-communication');
const ElementMention = require('system/util/element-mention');
const LinkModel = require('system/domain/entity/link');
const SyncStatesModel = require('system/domain/entity/sync-states');
const SyncStateView = require('system/ui/view/sync-state');
const ElementDescriptionViewerView = require('system/ui/view/detail/description-viewer');
const Template = require('system/ui/template/detail/link-info.hbs');
const Marked = require('balus/util/marked');

const LinkInfoView = Mn.View.extend({
    model: LinkModel,
    className: 'link-info',
    template: Template,
    regions: {
        description: '.description-wrapper',
        syncState: '.sync-states',
        nav: '.nav',
        navContent: '.nav-content'
    },
    events: {
        'click .add-comment': 'addComment',
        'click .enter-edit': 'enterEdit',
        'click .move-to': 'moveTo',
        'click .close-pane': function(){this.trigger('hide')}
    },

    initialize: function(params) {
        this._diagram = params.diagram;
        this._channel = this.getOption('channel');

        this.listenTo(this.model, 'change:edit',
            this.trigger.bind(this, 'change:edit'));
        this.listenTo(this._diagram.getLinkMeta(this.model.id),
            'remove', this.remove);
    },

    serializeData: function() {
        const json = this.model.toJSON();
        json['editable'] = this.getOption('auth').isLinkDetailEditable();
        json['type'] = this.model.i18nType();
        const desc = json.description ? json.description : '';
        json['description'] = Marked()(desc);

        return json;
    },

    onRender: function() {
        if (this.model.get('description')) {
            const descriptionViewer = new ElementDescriptionViewerView();
            const json = this.model.toJSON();
            json['description'] = Marked()(json['description']);
            $('#modal-container').append(
                descriptionViewer.render(json).el);
        }

        this.$('.description, .description-content').magnificPopup({
            delegate: 'p:parent img',
            type: 'image',
            gallery: {enabled: true},
            callbacks: {
                elementParse: function (item) {
                    item.src = item.el.attr('src');
                }
            }
        });

        this.$('.description, .description-content').externalLinkTargetBlank();

        // sync state
        this.getRegion('syncState').show(new SyncStateView({
            model: new SyncStatesModel({
                models: [
                    this.model.syncState,
                    this._diagram.getLinkMeta(
                        this.model.id).syncState
                ]
            })
        }));

        (new ElementMention(this._context, this._channel)).addClickHandler($(this));


        this.showChildView('navContent', new ElementCommunication({
            model: this.model,
            context: this.getOption('newContext'),
            parentContent: this.$('.content'),
            navRegion: this.getRegion('nav')
        }));

        return this;
    },

    enterEdit: function() {
        this.model.startEdit();
    },

    moveTo: function() {
        this._channel.request('canvas:zoomTo', this.model);
    },

    addComment: function() {
        this.trigger('add:comment', this.model);
    },

    filterComment: function() {
        this.trigger('filter:comment',
            this.model.toString({idLength: 10}) + ' ');
    },
});

module.exports = LinkInfoView;



// WEBPACK FOOTER //
// ./system/ui/view/detail/link-info.js